import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import styles from "../index.module.scss";
import { Link, useHistory, useParams } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import { AppData } from "../../../../context/context";
import ConfigForm from "./ConfigForm";
import axios from "axios";
import swal from "sweetalert";
import UrlLinks from "../../../../UrlLinks";

export default function JobConfig() {
  const { jobId } = useParams();
  const { setFormMode } = useContext(AppData);
  const [profileAttr, setProfileAttr] = useState([]);
  const [selectedAttrProfile, setSelectedAttrProfile] = useState([]);
  const [selectedAttrDocuments, setSelectedAttrDocuments] = useState([]);
  const [documentsAttr, setdocumentsAttr] = useState([]);
  const [profileEnabled, setProfileEnabled] = useState(false);
  const [DocumentEnabled, setDocumentEnabled] = useState(false);
  const [ScreeningEnabled, setScreeningEnabled] = useState(false);
  const [TrainingEnabled, setTrainingEnabled] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [reapply, setReapply] = useState(false);
  const [totalMarks, setTotalMarks] = useState(0);
  const [passingMarks, setPassingMarks] = useState(0);
  const [trainingModules, setTrainingModules] = useState([]);
  const [selectedTrainingModule, setSelectedTrainingModule] = useState(null);
  const [trainingModuleId, setTrainingModuleId] = useState("");
  const history = useHistory();

  const isSaveDisabled =
  (profileEnabled && selectedAttrProfile.length === 0) ||
  (DocumentEnabled && selectedAttrDocuments.length === 0) ||
  (ScreeningEnabled && (questions.length === 0 || !passingMarks || passingMarks > totalMarks)) ||
  (TrainingEnabled && (!selectedTrainingModule || !trainingModuleId));

  const handleDelete = async (questionId, questionMarks) => {
      const isTemporary =
        typeof questionId === "string" && questionId.startsWith("temp");
  
      if (!isTemporary) {
        const userId = localStorage.getItem("userID");
        try {
          await axios.post(
            `${UrlLinks.baseUrl}task-job/deleteScreeningQuestion?insertedBy=${userId}&questionId=${questionId}`
          );
        } catch (error) {
          console.log("Error deleting question:", error);
        }
      }
  
      setQuestions((prevQuestionArray) =>
        prevQuestionArray.filter((question) => question.questionId !== questionId)
      );
      setTotalMarks((prev) => prev - questionMarks);
    };

  const clearAll = async () => {
    await Promise.all(
      questions.map((q) => handleDelete(q.questionId, q.marks))
    );
  };

  const saveJobConfig = async () => {
    try {
      const response = await axios.post(
        `${UrlLinks.baseUrl}/job/saveJobConfig`,
        {
          jobId,
          profile: {
            enabled: profileEnabled,
            ...(profileEnabled && {
              selectedAttributes: selectedAttrProfile.map((i) => ({
                title: i.attribute,
                mustHave: i.mandate ? 2 : 1,
              })),
            }),
          },
          document: {
            enabled: DocumentEnabled,
            ...(DocumentEnabled && {
              selectedAttributes: selectedAttrDocuments.map((i) => ({
                title: i.attribute,
                mustHave: 1,
              })),
            }),
          },
          screening: {
            enabled: ScreeningEnabled,
          },
          training: {
            enabled: TrainingEnabled,
            ...(TrainingEnabled && selectedTrainingModule && trainingModuleId && {
              trainingFields: [{
                moduleId: parseInt(trainingModuleId),
                moduleType: selectedTrainingModule.moduleType,
              }],
            }),
          },
        }
      );
    } catch (error) {
      console.log(error);
    }
  };
  async function handleQuestionsSubmit() {

    const formDataToSend = questions.map((question) => ({
      ...question,
      answerId: typeof (question.answerId) === "number" ? question.answerId : 0, 
      answerList: question.answerList.map((opt) => ({
        ...opt,
        option_id: typeof (opt.option_id) === "number" ? opt.option_id : 0
      })),
      questionId:
        typeof question.questionId === "string" &&
        question.questionId.startsWith("temp")
          ? 0
          : question.questionId,
      // totalMarks,
      isMandatory: 1,
      // passingMarks,
    }));

    if(!ScreeningEnabled){
      await clearAll()
    }

    const strBody = {
      questionList: ScreeningEnabled ? formDataToSend : [],
      reapply: reapply ? 1 : 0,
      jobId,
      totalMarks,
      passingMarks,
    };

    const userId = localStorage.getItem("userID");

    try {
      const response = await axios.post(
        `${UrlLinks.baseUrl}task-job/addEditScreeningQuestion?insertedBy=${userId}`,
        strBody
      );

      if (response.status === 200 && response.data.code !== 1001) {
        swal("Job saved successfully", "", "success");
        history.push("/jobsdb");
      } else {
        swal("Duplicate Options", "", "error");
      }
    } catch (error) {
      console.error("Error submitting questions:", error);
      swal("Submission failed", "", "error");
    }
  }

  useEffect(() => {
    const checkEnabled = async () => {
      try {
        const response = await axios.get(
          `${UrlLinks.baseUrl}job/getJobConfigFields?jobId=${jobId}`
        );
        if (response.data.code === 1000) {
          const flags = {
            profile: response.data.response.includes(1),
            document: response.data.response.includes(2),
            screening: response.data.response.includes(3),
            training: response.data.response.includes(4),
          };
          setProfileEnabled(flags.profile);
          setDocumentEnabled(flags.document);
          setScreeningEnabled(flags.screening);
          setTrainingEnabled(flags.training);
          return flags;
        }
      } catch (error) {
        console.log(error);
      }
      return {};
    };

    const fetchProfileAttr = async () => {
      try {
        const response = await axios.get(
          `${UrlLinks.baseUrl}configmaster/?category_sub_type=profile&category_type=job_config`
        );
        if (response.data.code === 1000) {
          const content = response.data.response.content;
          setProfileAttr(content.map((i) => i.typeValue));
        }
      } catch (error) {
        console.log(error);
      }
    };

    const fetchDocumentsAttr = async () => {
      try {
        const response = await axios.get(
          `${UrlLinks.baseUrl}configmaster/?category_sub_type=document&category_type=job_config`
        );
        if (response.data.code === 1000) {
          const content = response.data.response.content;
          setdocumentsAttr(content.map((i) => i.typeValue));
        }
      } catch (error) {
        console.log(error);
      }
    };

    const checkAvailFieldsWithMandate = async () => {
      try {
        const fieldsRes = await axios.get(
          `${UrlLinks.baseUrl}job/v2/getJobScreenFields?jobId=${jobId}`
        );

        if (fieldsRes.data.code === 1000) {
          if (fieldsRes.data.response["profile"]) {
            setSelectedAttrProfile(
              fieldsRes.data.response["profile"].map((i) => ({
                attribute: i.fieldName,
                mandate: i.isRequired === 2 ? true : false,
              }))
            );
          }

          if (fieldsRes.data.response["document"]) {
            setSelectedAttrDocuments(
              fieldsRes.data.response["document"].map((i) => ({
                attribute: i.fieldName,
                mandate:
                  i.fieldName === "Aadhaar Card" || i.fieldName === "PAN Card"
                    ? true
                    : i.isRequired === 2
                    ? true
                    : false,
              }))
            );
          }

          if (fieldsRes.data.response["training"]) {
            const tr = fieldsRes.data.response["training"];
            setSelectedTrainingModule({
              moduleType: tr.moduleType,
              moduleId: tr.moduleId,
            });
            setTrainingModuleId(`${tr.moduleId || ""}`);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    const fetchScreeningData = async () => {
      try {
        const response = await axios.get(
          `${UrlLinks.baseUrl}/task-job/getJobQuestions?jobId=${jobId}`
        );
        if (response.data && response.data.questionList) {
          setQuestions(response.data.questionList);
          setReapply(response.data.reapply);
          if (response.data.questionList.length === 0) {
            setTotalMarks(0);
            setPassingMarks(0);
          } else {
            setTotalMarks(response.data.totalMarks || 0);
            setPassingMarks(response.data.passingMarks || 0);
          }
        }
      } catch (error) {
        console.log("Error fetching questions:", error);
      }
    };

    const fetchTrainingModules = async () => {
      try {
        const TrainingModules = [
          { moduleId: 1, moduleType: "ASSESSMENT" },
          { moduleId: 2, moduleType: "COURSE" },
          { moduleId: 3, moduleType: "PLAYLIST" },
        ];
        setTrainingModules(TrainingModules);

      } catch (error) {
        console.log("Error fetching training modules:", error);
      }
    };

    const init = async () => {
      await checkEnabled();
      await fetchProfileAttr();
      await fetchDocumentsAttr();
      await fetchTrainingModules();
      await checkAvailFieldsWithMandate();
      await fetchScreeningData();
    };

    init();
  }, [jobId]);

  return (
    <section className={styles.configContainer}>
      <section className={styles.jobConfigModule}>
        <section className={styles.header}>
          <div className={styles.title}>
            <Link
              to={`/jobsdb/eligibilityCriteria/${jobId}`}
              style={{ textDecoration: "none" }}
            >
              <ArrowBackIcon
                sx={{
                  color: "black",
                  fontSize: "40",
                  marginBottom: "-5px",
                }}
                onClick={() => {
                  setFormMode("create");
                }}
              ></ArrowBackIcon>
            </Link>
            <span>Application Configuration</span>
          </div>
          <div className={styles.subTitle}>
            Using this page, configure the application stages for this job as
            per the need
          </div>
        </section>
        <section className={styles.container}>
          <ConfigForm
            title="Profile Data"
            subtitle="Add profile questions necessary for application"
            availAttr={profileAttr}
            setAvailAttr={setProfileAttr}
            selectedAttr={selectedAttrProfile}
            setSelectedAttr={setSelectedAttrProfile}
            isEnabled={profileEnabled}
            setIsEnabled={setProfileEnabled}
            stage={1}
          />
          <ConfigForm
            title="Screening"
            subtitle="Initial candidate evaluation process"
            isEnabled={ScreeningEnabled}
            questions={questions}
            setQuestions={setQuestions}
            totalMarks={totalMarks}
            setTotalMarks={setTotalMarks}
            passingMarks={passingMarks}
            reapply={reapply}
            setReapply={setReapply}
            setPassingMarks={setPassingMarks}
            setIsEnabled={setScreeningEnabled}
            stage={2}
          />
          <ConfigForm
            title="Documents"
            subtitle="Add documents necessary for application"
            availAttr={documentsAttr}
            setAvailAttr={setdocumentsAttr}
            setSelectedAttr={setSelectedAttrDocuments}
            selectedAttr={selectedAttrDocuments}
            isEnabled={DocumentEnabled}
            setIsEnabled={setDocumentEnabled}
            stage={3}
          />
          <ConfigForm
            title="Training"
            isEnabled={TrainingEnabled}
            setIsEnabled={setTrainingEnabled}
            subtitle="Add training module for the application"
            stage={4}
            availAttr={trainingModules}
            selectedTrainingModule={selectedTrainingModule}
            setSelectedTrainingModule={setSelectedTrainingModule}
            trainingModuleId={trainingModuleId}
            setTrainingModuleId={setTrainingModuleId}
          />
        </section>
      </section>
      <section className={styles.footer}>
        <button
          className={`${styles.footerSaveBtn} ${
            isSaveDisabled ? styles.footerSaveBtnDisable : ""
          }`}
          disabled={isSaveDisabled}
          onClick={async () => {
            await saveJobConfig();
            await handleQuestionsSubmit();
          }}
        >
          SAVE
        </button>
      </section>
    </section>
  );
}
